import { memo } from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const BzCarousel = ({ objSettings, ...props }) => {
  return (
    <Slider {...objSettings}{...props}>
      {props.children}
    </Slider>
  );
};

BzCarousel.propTypes = {
  objSettings: PropTypes.object
};

export default memo(BzCarousel);
